var React = require('react');

function LsHeaderIconInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.667 10.667H1.333V1.333H6V0H1.333C0.979467 0 0.640413 0.140441 0.390427 0.390427C0.140441 0.640413 3.75127e-07 0.979466 3.75127e-07 1.333V10.666C-0.00013101 10.8411 0.0342512 11.0146 0.101182 11.1764C0.168113 11.3383 0.26628 11.4853 0.390073 11.6092C0.513867 11.7331 0.66086 11.8314 0.822652 11.8984C0.984444 11.9655 1.15786 12 1.333 12H10.666C11.0194 11.9992 11.3581 11.8585 11.6081 11.6088C11.858 11.359 11.9989 11.0204 12 10.667V6H10.667V10.667ZM7.333 0V1.333H9.726L3.173 7.887L4.113 8.827L10.666 2.274V4.667H12V0H7.333Z","fill":"currentColor"}));
}

LsHeaderIconInline.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none"};

module.exports = LsHeaderIconInline;

LsHeaderIconInline.default = LsHeaderIconInline;
